// extracted by mini-css-extract-plugin
module.exports = {"projects":"FeaturedProjects-module--projects--2ZtHM","button":"FeaturedProjects-module--button--1WnlP"};